import logo from './logo.svg';
import './App.css';
import React, {useEffect} from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation, Navigate } from "react-router-dom";
import Header from './components/common/Header';
import OtherItems from './components/common/OtherItems';
import RequireAuth from './components/RequireAuth';
import ComingSoon from './components/ComingSoon';
import Home from './components/Home';
import Login from './components/Login';
import KnowledgeCenter from './components/KnowledgeCenter';
import ErrorPage from './components/ErrorPage';
import Cookie from './components/common/Cookie';
import Sessions from './components/Sessions';
import TopicAdd from './components/topic/TopicAdd';
import TopicList from './components/topic/TopicList';
import TopicDetail from './components/topic/TopicDetail';
import MyAccount from './components/MyAccount';
import PaginationComponent from './components/Pagination';
import Search from './components/Search';
import WordCloudPage from './components/WordCloudPage';

//import EditorCheck from './EditorCheck';

function App() {

  // Allow WordCloud access only for specific email IDs
  const AllowedEmails = ['nitin.chouhan@clear-trail.com', 'just@gmail.com'];

  const WordCloudGuard = () => {
    let authlogin = localStorage.getItem('authlogin');
    let storageData = authlogin ? JSON.parse(authlogin) : {};
    const email = (storageData.user_email || '').toLowerCase();
    if (AllowedEmails.includes(email)) {
      return <WordCloudPage />;
    }
    // Option 1: show error page
    return <ErrorPage />;
    // Option 2 (if you prefer redirect): return <Navigate to="/" replace />;
  };

  return (
    <div className="App">

        <Router>
          {/*******set cookie on loing page*********/}
          <Cookie />

          {/***********Header run single time when load the page, it will not run on routing of pages*************/}
          <Header /> 
          
          <OtherItems />
                            
          <Routes>

              <Route path="/" element={<RequireAuth><Home /></RequireAuth>} />
              <Route path="/knowledge-center/" element={<RequireAuth><KnowledgeCenter /></RequireAuth>} />
              {/* <Route path="/home-live" element={<RequireAuth><Home /></RequireAuth>} /> */}

              <Route path="/sessions/" element={<RequireAuth><Sessions /></RequireAuth>} />
              <Route path="/sessions/:year/:id" element={<RequireAuth><Home /></RequireAuth>} />

              <Route path="/my-account" element={<RequireAuth><MyAccount /></RequireAuth>} />

              <Route path="/add-query" element={<RequireAuth><TopicAdd /></RequireAuth>} />
              <Route path="/queries" element={<RequireAuth><TopicList /></RequireAuth>} />
              <Route path="/query/:id" element={<RequireAuth><TopicDetail /></RequireAuth>} />
              <Route path="/search/:text" element={<RequireAuth><Search /></RequireAuth>} />

              <Route path="/pagination" element={<RequireAuth><PaginationComponent /></RequireAuth>} />

              {/* Word Cloud page */}
              <Route path="/word-cloud" element={<RequireAuth><WordCloudGuard /></RequireAuth>} />

              {/* <Route path="/editorcheck" element={<EditorCheck />} /> */}

              
              <Route path="/login" element={<Login />} />
              <Route path="*" element={<ErrorPage />} />

          </Routes>



      </Router>
    </div>
  );
}

export default App;
